import React from "react";
import { Check, Clock } from "lucide-react";
import { ProductStatusProps } from "./types";

export const ProductStatus: React.FC<ProductStatusProps> = ({ status }) => {
  const [date] = status.paidDetails.expireDate.split(" ");
  const isExpire = new Date(date) < new Date();
  if (status.isPurchased) {
    return (
      <div className="flex items-center gap-2 text-green-600">
        <Check className="w-5 h-5" />
        <span className="text-sm font-medium">Purchased</span>
      </div>
    );
  }

  if (status.isEnabled) {
    return (
      <div className="flex items-center gap-2 text-blue-600">
        <Clock className="w-5 h-5" />
        <span className="text-sm font-medium">Available</span>
      </div>
    );
  }

  if (
    isExpire &&
    !status.paidDetails.paymentStatus.includes("Failed") &&
    status.paidDetails.tier !== ""
  ) {
    return (
      <div className="flex items-center gap-2 text-red-600">
        <Clock className="w-5 h-5" />
        <span className="text-sm font-medium">Expired</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-gray-600">
      <Clock className="w-5 h-5" />
      <span className="text-sm font-medium">Not Purchased</span>
    </div>
  );
};
